import E3DAppInitializerContainer from './E3DAppInitializerContainer'

export default E3DAppInitializerContainer 